import { isDefined } from '@sgme/fp';

import { useUserContext } from '@/context/UserContext.tsx';
import { useAppDispatch } from '@/store/hooks.ts';
import { onClickNewTabButton } from '@/store/tabs/slice.ts';

export function AddTabButton() {
  const dispatch = useAppDispatch();
  const { defaultClient } = useUserContext();

  const onClick = () => {
    const clientId = defaultClient?.companyId;

    if (isDefined(clientId)) {
      dispatch(onClickNewTabButton({ clientId }));
    } else {
      console.warn("Warning: try to create new tab but default client id couldn't be found");
    }
  };

  return (
    <button type="button" className="btn btn-icon btn-lg btn-flat-secondary" data-e2e="add-tab-btn" onClick={onClick}>
      <i className="icon icon-md">add</i>
    </button>
  );
}
